import Vue from 'vue'
import Vuex from 'vuex'
import { post, get, DEV_ENDPOINT, PRODUCTION_ENDPOINT, put, destroy } from './helpers/api'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    user_id: null,
    user: 'null',
    api_token: null,
    parkirisca: [],
    validacije: [],
    parkirisce: null,
    omejitve: [],
    rfid_uporabniki: [],
    permissions: [],
    loader: false,
    loaderText: ''

  },
  mutations: {
    setToken(state, api_token) {
      state.api_token = api_token;
      localStorage.setItem('access_token', api_token);
    },

    setUserID (state, id) {
      state.user_id = id;
      localStorage.setItem('user_id', id)
    },

    setUser(state, user) {
      state.user = user;
      localStorage.setItem('user', user)
    },

    setParkirisca (state, parkirisca) {
      state.parkirisca = parkirisca
    },

    setValidacije (state, items) {
      state.validacije = items
    },

    addValidacija (state, item) {
      state.validacije.unshift(item)
    },

    setParkirisce (state, item) {
      state.parkirisce = item
      localStorage.setItem('parkirisce', JSON.stringify(item))
    },

    setOmejitve (state, omejitve) {
      state.omejitve = omejitve
    },

    setUporabniki (state, items) {
      state.rfid_uporabniki = items
    },

    setUserPermissions (state, permissions) {
      state.permissions = permissions
      localStorage.setItem('permissions', JSON.stringify(permissions))
    },

    setLoader(state, value) {
      state.loader = value
    },

    setLoaderText(state, text) {
      state.loaderText = text
    },
  },

  actions: {
    LOGIN (context, credentials) {
      return new Promise((resolve, reject) => {
        post(DEV_ENDPOINT + 'oauth/token', credentials)
          .then(response => {
            context.commit('setToken', response.data.access_token)
            resolve(response)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },

    LOGOUT (context) {
      return new Promise ((resolve, reject) => {
        get(DEV_ENDPOINT + 'api/v1/user/logout')
          .then(response => {
            context.commit('setUserID', null)
            context.commit('setUser', null)
            context.commit('setToken', null)
            context.commit('setParkirisca', [])
            context.commit('setValidacije', [])
            context.commit('setUporabniki', [])
            context.commit('setOmejitve', [])
            context.commit('setUserPermissions', [])
            //context.commit('setParkirisce', null)
            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
      })
    },

    USER_DATA (context) {
      return new Promise((resolve, reject) => {
        get(DEV_ENDPOINT + 'api/v1/user/parkirisca')
          .then(response => {
            context.commit('setUserID', response.data.user.id)
            context.commit('setUser', response.data.user.name)
            context.commit('setParkirisca', response.data.data)
            context.commit('setUserPermissions', response.data.user.permissions)
            
            var park_st_exists = false;

            response.data.data.forEach(function(item) {
              if(item.st_park == context.state.parkirisce) {
                park_st_exists = true
              }
            });

            if(!park_st_exists) {
              context.commit('setParkirisce', null)
            }

            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
      })
    },

    VALIDACIJE (context) {
      return new Promise((resolve, reject) => {
        get(DEV_ENDPOINT + 'api/v1/user/validacije')
          .then(response => {
            if(response.data.data.length > 0) {
              let items = [];
              for(let i=0; i<response.data.data.length; i++) {
                let item = {};
                item.id = response.data.data[i].id
                item.ParkNum = response.data.data[i].ParkNum
                item.ParkingTime = response.data.data[i].ParkingTime
                item.SerNum = response.data.data[i].SerNum
                item.Parkirisce = response.data.data[i].Parkirisce
                items.push(item)
              }
              context.commit('setValidacije', items)
            }

            resolve(response)
          })
          .catch(error => {
            window.console.log(error)
            reject(error)
          })
      })
    },

    STORE_VALIDACIJA(context, item) {
      return new Promise((resolve, reject) => {
        //post('http://validator.test/api/v1/user/validacija', item)
        //post('https://validator.vurnikov-trg.si/cloud/public/api/v1/user/validacija', item)
        post(DEV_ENDPOINT + 'api/v1/user/validacija', item)
          .then(response => {
            if(response.data.data.length > 0) {
              let items = [];
              for(let i=0; i<response.data.data.length; i++) {
                let item = {};
                item.id = response.data.data[i].id
                item.ParkNum = response.data.data[i].ParkNum
                item.ParkingTime = response.data.data[i].ParkingTime
                item.SerNum = response.data.data[i].SerNum
                item.Parkirisce = response.data.data[i].Parkirisce

                items.push(item)
              }
              context.commit('setValidacije', items)
              resolve(response)
            }
          })
          .catch(error => {
            reject(error)
          })
      })
    },

    OMEJITVE (context) {
      return new Promise((resolve, reject) => {
        get(DEV_ENDPOINT + 'api/v1/omejitve')
        .then(response => {
          let items = []
          let brez_omejitve = {
            Naziv_omejitve: 'Brez omejitev',
            St_omejitve: ''
          }
          if(response.status == 200 && response.data.length > 0) {
            items = response.data
            items.unshift(brez_omejitve)
          }
          context.commit('setOmejitve', items)
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
      })
    },

    RFID_UPORABNIKI (context) {
      return new Promise((resolve, reject) => {
        get(DEV_ENDPOINT + 'api/v1/uporabniki')
        .then(response => {
          let items = []
          if(response.status == 200 && response.data.length >= 0) {
            items = response.data
            context.commit('setUporabniki', items)
          }
          resolve(response)

        })
        .catch(error => {
          reject(error)
        })
      })
    },

    STORE_RFID_UPORABNIK (context, payload) {
      return new Promise((resolve, reject) => {
        post(DEV_ENDPOINT + 'api/v1/rfid-uporabnik', payload)
          .then(response =>{
            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
      })
    },

    GET_RFID_UPORABNIK (context, uuid) {
      return new Promise((resolve, reject) => {
        get(DEV_ENDPOINT + 'api/v1/rfid-uporabnik/' + uuid )
          .then(response => {
            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
      })
    },

    UPDATE_RFID_UPORABNIK (context, payload) {
      return new Promise((resolve, reject) => {
        put(DEV_ENDPOINT + 'api/v1/rfid-uporabnik/update', payload)
          .then(response => {
            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
      })
    },

    DESTROY_RFID_UPORABNIK (context, uuid) {
      return new Promise((resolve, reject) => {
        destroy(DEV_ENDPOINT + 'api/v1/rfid-uporabnik/' + uuid)
          .then(response => {
            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
      })
    },

    CONVERT_RFID_NR (context, nr) {
      return new Promise((resolve, reject) => {
        post(DEV_ENDPOINT + 'api/v1/rfid-nr', nr)
          .then(response => {
            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
      })
    },

    RFID_NR_SEARCH (context, nrSearch) {
      return new Promise( (resolve, reject) => {
        get(DEV_ENDPOINT + 'api/v1/search/rfid-nr/' + nrSearch)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
      })
    }


  },

  getters: {
    user (state) {
      return state.user
    },

    userId (state) {
      return state.user_id
    },

    parkirisca (state) {
      return state.parkirisca
    },

    validacije (state) {
      return state.validacije
    },

    parkirisce(state) {
      return state.parkirisce
    },

    omejitve (state) {
      return state.omejitve
    },

    uporabniki (state) {
      return state.rfid_uporabniki
    },

    permissions(state) {
      return state.permissions
    },

    loader (state) {
      return state.loader
    },

    loaderText (state) {
      return state.loaderText
    },
  },


})
